import { render, staticRenderFns } from "./PrintDescription.vue?vue&type=template&id=867ea5ba&scoped=true&"
import script from "./PrintDescription.vue?vue&type=script&lang=js&"
export * from "./PrintDescription.vue?vue&type=script&lang=js&"
import style0 from "./PrintDescription.vue?vue&type=style&index=0&id=867ea5ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "867ea5ba",
  null
  
)

export default component.exports